import React, { createContext, useContext } from "react";

type ConversationState = {
  isChatBusy: boolean;
};

const ConversationStateContext = createContext<ConversationState | undefined>(
  undefined,
);

export const ConversationStateProvider: React.FC<
  React.PropsWithChildren<{ state: ConversationState }>
> = ({ children, state }) => {
  return (
    <ConversationStateContext.Provider value={state}>
      {children}
    </ConversationStateContext.Provider>
  );
};

export const useConversationState = (): ConversationState => {
  const context = useContext(ConversationStateContext);
  if (!context) {
    throw new Error(
      "useConversationState must be used within a ConversationStateProvider",
    );
  }
  return context;
};
